import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useRouter } from 'expo-router';
import { useThemeColors } from '../constants/theme';
import { esInvitado } from '../services/modoInvitado';

/**
 * Cintillo que aparece SOLO en modo vista previa (invitado sin cuenta).
 *
 * POR QUÉ EXISTE
 * Los paneles de negocio — flota, restaurante, escuela, CRM — se alimentan de
 * datos que un invitado no tiene. Sin explicación, ve una pantalla vacía y
 * concluye lo mismo que concluyó el revisor de Google: "la app no carga".
 *
 * Con este cintillo la pantalla vacía deja de ser un error y pasa a ser un
 * estado entendible: "estás mirando, todavía no hay nada tuyo aquí".
 *
 * Se pinta solo cuando corresponde: si hay cuenta, no renderiza nada.
 */
export default function AvisoVistaPrevia({ que }: { que?: string }) {
  const colors = useThemeColors();
  const router = useRouter();

  if (!esInvitado()) return null;

  return (
    <View style={[styles.caja, { backgroundColor: colors.card, borderColor: colors.accent }]}>
      <Ionicons name="eye-outline" size={20} color={colors.accent} style={{ marginTop: 1 }} />
      <View style={{ flex: 1, marginLeft: 10 }}>
        <Text style={[styles.titulo, { color: colors.text }]}>Estás en vista previa</Text>
        <Text style={[styles.texto, { color: colors.textSecondary }]}>
          {que
            ? `Así se ve ${que}. Con tu cuenta aparecerán aquí tus datos reales.`
            : 'Estás explorando sin cuenta, por eso esta pantalla se ve vacía. Con tu cuenta aparecerán tus datos reales.'}
        </Text>
      </View>
      <TouchableOpacity
        onPress={() => router.push('/auth')}
        style={[styles.boton, { backgroundColor: colors.accent }]}
        accessibilityRole="button"
      >
        <Text style={styles.botonTexto}>Crear cuenta</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  caja: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: 14,
    borderRadius: 14,
    borderWidth: 1.5,
    marginBottom: 16,
  },
  titulo: { fontSize: 14, fontWeight: 'bold', marginBottom: 2 },
  texto: { fontSize: 12, lineHeight: 17 },
  boton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 10,
    marginLeft: 8,
    alignSelf: 'center',
  },
  botonTexto: { color: '#FFF', fontSize: 12, fontWeight: 'bold' },
});
